module.exports = __webpack_public_path__ + "media/images/icons/google-black-c2b4a27d92a19ae80bd399d0e03dc2ef.svg";